import React, { useCallback, useEffect, useRef } from 'react';
import { useRouter } from '@uirouter/react';
import { useSystemData } from './useSystemData';
import SystemStatSection from './SystemStatSection';
import TableSkeleton from '../../../../core/components/TableSkeleton';
import datamonitorRepo from '../../data/datamonitorRepo';

const REFRESH_MS = 40000;
const IDLE_LIMIT_MS = 20 * 60 * 1000;

type SystemSection = 'system' | 'integrity';

const SystemTab = (): JSX.Element => {
    const router = useRouter();
    const { init, waiting, error, system, integrity, load, toggle } = useSystemData();
    const lastActivityRef = useRef(Date.now());

    useEffect(() => {
        lastActivityRef.current = Date.now();
        load();

        const timer = window.setInterval(() => {
            // legacy: bounce idle users back home instead of polling forever
            if (Date.now() - lastActivityRef.current > IDLE_LIMIT_MS) {
                window.clearInterval(timer);
                router.stateService.go('home', {}, { reload: 'home' });
                return;
            }
            load();
        }, REFRESH_MS);

        return (): void => window.clearInterval(timer);
    }, [load, router]);

    const handleToggle = useCallback(
        (section: SystemSection, id: string): void => {
            lastActivityRef.current = Date.now();
            toggle(section, id);
        },
        [toggle],
    );

    const handleDetail = useCallback((): void => {
        lastActivityRef.current = Date.now();
        datamonitorRepo.getRemittanceExcel();
    }, []);

    if (init || waiting) {
        return (
            <TableSkeleton
                columns={5}
                rows={8}
                sections={2}
            />
        );
    }

    return (
        <div className="datamonitor-system">
            {error ? <div className="datamonitor-system-error">{error}</div> : null}
            <SystemStatSection
                variant="system"
                rows={system}
                onToggle={handleToggle}
            />
            <SystemStatSection
                variant="integrity"
                title="DATA INTEGRITY"
                rows={integrity}
                onToggle={handleToggle}
                onDetail={handleDetail}
            />
        </div>
    );
};

export default SystemTab;
